import { render, staticRenderFns } from "./human-resource.vue?vue&type=template&id=5885b364&scoped=true"
import script from "./human-resource.vue?vue&type=script&lang=js"
export * from "./human-resource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5885b364",
  null
  
)

export default component.exports